export default {
    TITULO_SISTEMA: 'Ventas',
    NOMBRE_EMPRESA: 'Marketbo',
    SITIO_WEB_EMPRESA: 'https://marketbo.com',

    API_REST: '/api',

    KEY_RECAPTCHA: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',

    FECHA_VENTA_EDITABLE: false
};

